import {action, observable} from 'mobx';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';

class ItemStore {
    constructor() {

    }

    init() {

    }

    /**
     * 账户信息
     * @type {null}
     */
    @observable
    id = '';
    @observable
    username = '';

    /**
     * 控制 modal 是否显示
     */
    @observable
    is_modal_show = false;

    /**
     * 打开 modal 显示
     */
    @action
    openModal(id, username) {
        this.is_modal_show = true;
        this.id = id;
        this.username = username;
    }

    /**
     * 关闭 modal 显示
     */
    @action
    closeModal() {
        this.is_modal_show = false;
    }

    @observable
    filter;

    @observable
    search_result;

    /**
     * 统计报表
     * @param {Object} option
     */
    async search(option) {
        let url = fetchUrl.pandect.getReport;
        let result = await service.fetchData({
            path: url,
            params: {
                uid: option.uid,
                nextProxyType: option.nextProxyType,
                startTime: option.startTime,
                endTime: option.endTime
            }
        });
        return result;
    }
}

let item_store = new ItemStore();

export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Pandect/MySummary/BetStatisticStore.js